export default function Trust() {
  const features = [
    {
      icon: 'ri-file-list-3-line',
      title: '建設業許可・労務安全書類に精通',
      description: '建設業法に基づく書類作成の専門知識を持ち、法令遵守を徹底します'
    },
    {
      icon: 'ri-shield-check-line',
      title: '書類不備の防止',
      description: '提出前の厳密なチェックで不備をゼロに'
    },
    {
      icon: 'ri-checkbox-multiple-line',
      title: '元請提出フォーマットに完全対応',
      description: '各元請会社の独自フォーマットにも柔軟に対応し、スムーズな提出を実現'
    },
    {
      icon: 'ri-computer-line',
      title: '電子システムの登録・代行も可',
      description: 'グリーンサイト等の電子システムへの登録・更新作業も全て代行します'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-[#fafaf8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-3">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2332] mb-4">
              なぜ行政書士なのか
            </h2>
            <div className="w-20 h-1 bg-[#ff6b35] mb-8 sm:mb-12"></div>

            <div className="space-y-6 sm:space-y-8 mb-8 sm:mb-12">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4 sm:gap-6">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#ff6b35] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl sm:text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-[#1a2332] mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button className="px-6 sm:px-8 py-3 sm:py-4 bg-[#e8f5e9] text-[#1a2332] text-sm sm:text-base font-medium rounded-full hover:bg-[#d4edda] transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer">
              詳しく見る
              <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
            </button>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 sm:gap-16 mt-12 sm:mt-20">
              <div>
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1a2332]">グリーンサイト対応実績多数</div>
              </div>
              <div>
                <div className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#1a2332] mb-2">98%</div>
                <div className="text-sm sm:text-base text-gray-600">顧客満足度</div>
              </div>
            </div>
          </div>

          {/* Right Image Card */}
          <div className="lg:col-span-2">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl h-[400px] sm:h-[500px] lg:h-[600px]">
              <img 
                src="https://public.readdy.ai/ai/img_res/28d7bd93ad51aefb7b4455dddebd48af.jpg"
                alt="行政書士による書類確認"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 sm:top-6 left-4 sm:left-6">
                <div className="px-4 sm:px-6 py-2 sm:py-3 bg-white rounded-full text-[#1a2332] text-xs sm:text-sm font-bold shadow-lg whitespace-nowrap">
                  行政書士ARISEリーガルオフィス
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 sm:p-8">
                <p className="text-white text-lg sm:text-xl font-bold mb-2">専門家による確実なサポート</p>
                <p className="text-white text-sm sm:text-base">書類不備ゼロを実現</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
